<template>
  <!-- 模块容器 -->
  <div class="relative w-full h-auto py-[3.75vw]">
    <el-image
      class="absolute top-0 left-0 w-full h-full"
      :src="backgroundImage"
      lazy
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          蓝悦品牌故事
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          青少年航空科技创新教育践行者
        </div>
      </div>
    </div>

    <!-- 数据统计 -->
    <!-- 为数据统计容器添加 ref -->
    <div
      ref="statsContainer"
      class="stats-container relative w-full h-auto mx-auto flex justify-center gap-[4.58vw] font-harmony"
    >
      <div
        v-for="(item, index) in animatedStats"
        :key="index"
        class="flex flex-col items-center gap-[1.3vw]"
      >
        <!-- 数字部分：数字与加号分为两个 span -->
        <div
          class="flex flex-row items-center whitespace-nowrap text-[3.13vw] leading-[3.13vw] text-[#1A2233] text-center font-rubik font-normal"
        >
          <span>{{ item.current }}</span>
          <span class="plus" :class="{ 'fade-in': item.plusFaded }">+</span>
        </div>
        <!-- 文字部分：包裹在 label-wrapper 内 -->
        <div class="label-wrapper text-center" :style="{ width: '100%' }">
          <span
            class="text-[0.94vw] leading-[0.833vw] text-[#1A2233] text-center font-harmony font-normal"
            :class="{ 'label-fade': item.labelFaded }"
          >
            {{ item.label }}
          </span>
        </div>
      </div>
    </div>

    <!-- 容器区域 -->
    <div
      class="relative w-[61.46vw] h-auto mx-auto mt-[2vw] gap-[9vw] flex justify-between items-start"
    >
      <!-- 文字容器 -->
      <div class="w-auto h-auto mx-auto gap-[2.76vw] flex flex-col">
        <!-- 文字信息容器 -->
        <div class="text-left font-harmony">
          <!-- 段落内容 -->
          <p
            class="text-[0.833vw] text-[#676B73] font-normal leading-[1.25vw] text-justify mt-[1.25vw]"
            style="text-justify: inter-ideograph"
          >
            蓝悦教育以
            <span class="text-[#F28334] font-bold">“科学育人、启发开智”</span>
            为核心，专注于青少年航空科技创新教育。构建“课程-赛事-认证”闭环，对标教育部白名单赛事设计进阶体系，让孩子每一阶段学习都有明确目标与权威认证。依托教育部政策支持，结合无人机科技与学科知识（数学、物理、工程学等），
            <span class="text-[#05358C] font-bold"
              >打造沉浸式教学体系，激发学生探索精神，培养未来科技人才。</span
            >
          </p>

          <p
            class="text-[0.833vw] text-[#676B73] font-normal leading-[1.25vw] text-justify mt-[1.25vw]"
            style="text-justify: inter-ideograph"
          >
            我们始终坚信，每一架无人机的起飞，都是少年梦想的启航；每一次加盟合作，都是科技教育火种的传递。蓝悦教育，不止教授飞行技术，更培养孩子驾驭未来的勇气与智慧。
          </p>
        </div>

        <!-- 按钮容器 -->
        <el-button
          plain
          class="custom-el-button font-harmony"
          @mouseenter="hoverButton = true"
          @mouseleave="hoverButton = false"
          @click="$router.push({ name: 'AboutUs' })"
        >
          <div
            class="w-full h-full flex items-center justify-center gap-[0.52vw]"
          >
            <span>查看更多</span>
            <i class="el-icon-plus"></i>
          </div>
        </el-button>
      </div>

      <!-- 图片容器 -->
      <div
        class="w-[22.45vw] h-[23.39vw] my-auto flex items-center flex-shrink-0"
      >
        <el-image
          class="w-full h-full object-center object-cover rounded-l"
          :src="require('@/assets/images/Home/module2/sample2.png')"
          lazy
          alt="图片"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-module2",
  data() {
    return {
      backgroundImage: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/home/module2/sample1.png`,
      // 原始数据（target 为纯数字，便于计算动画）
      stats: [
        { target: 50, label: "合作院校" },
        { target: 100000, label: "服务学生" },
        { target: 60, label: "团队成员" },
        { target: 500, label: "荣获奖项" },
      ],
      animatedStats: [],
      animationTriggered: false,
    };
  },
  mounted() {
    // 初始化 animatedStats，current 用固定位数的字符串（初始全部为"0"）
    this.animatedStats = this.stats.map((item) => {
      const finalStr = String(item.target);
      let initial = "";
      for (let i = 0; i < finalStr.length; i++) {
        initial += "0";
      }
      return {
        target: item.target,
        current: initial,
        label: item.label,
        plusFaded: false,
        labelFaded: false,
      };
    });
    // 使用 IntersectionObserver 监听统计区域至少50%进入视口时触发动画
    // 调整观察器配置为完全进入视口触发
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animationTriggered) {
            // 添加可见类触发淡入
            entry.target.classList.add("visible");
            this.triggerAnimations();
            this.animationTriggered = true;
          }
        });
      },
      {
        threshold: 1, // 完全进入视口时触发
        rootMargin: "0px 0px -50px 0px", // 底部留50px缓冲
      }
    );
    observer.observe(this.$refs.statsContainer);
  },
  beforeDestroy() {
    // IntersectionObserver 无需手动移除
  },
  methods: {
    // 按钮点击跳转事件
    goToPage() {
      // 可以在这里添加其他逻辑
      this.$router.push({ name: "AboutUs" });
    },
    handleMouseDown() {
      this.$el.classList.add("active-state");
    },
    handleMouseUp() {
      this.$el.classList.remove("active-state");
      this.$el.blur();
    },
    // 启动所有动画
    triggerAnimations() {
      this.animatedStats.forEach((item, index) => {
        // 数字动画
        this.animateStat(index);
        // 同时启动加号与 label 的淡入动画
        this.$set(this.animatedStats[index], "plusFaded", true);
        this.$set(this.animatedStats[index], "labelFaded", true);
      });
    },
    // 数字动画：x秒内在固定位数基础上由快到慢随机变化，最终显示目标数字
    animateStat(index) {
      const startTime = performance.now();
      const duration = 1250;
      const target = this.animatedStats[index].target;
      const finalStr = String(target);
      const n = finalStr.length;

      // 初始化为0
      let currentValue = 0;
      this.$set(this.animatedStats[index], "current", "0".repeat(n));

      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // 计算当前值并格式化为固定位数
        currentValue = Math.floor(target * progress);
        const formatted = String(currentValue).padStart(n, "");

        this.$set(this.animatedStats[index], "current", formatted);

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          this.$set(this.animatedStats[index], "current", finalStr);
        }
      };
      requestAnimationFrame(update);
    },
  },
};
</script>

<style scoped>
/* 新增数字动画的初始显示过渡样式 */
.stats-container {
  opacity: 0;
  transition: opacity 0.5s ease;
}
.stats-container.visible {
  opacity: 1;
}
/* 自定义按钮样式 */
.custom-el-button {
  width: 6.25vw !important;
  height: 1.82vw !important;
  border-color: #e4e7ed !important;
  color: #676b73 !important;
  transition: all 0.3s ease !important;
}

/* 文字图标样式 */
.custom-el-button :deep(span),
.custom-el-button :deep(.el-icon-plus) {
  color: #676b73 !important;
  font-size: 0.73vw !important;
}

/* 悬停状态 */
.custom-el-button:hover {
  border-color: #05358c !important;
  color: #05358c !important;
  background-color: rgba(5, 53, 140, 0.1) !important;
}
.custom-el-button:hover :deep(span),
.custom-el-button:hover :deep(.el-icon-plus) {
  color: #05358c !important;
}

/* 加号淡入动画：初始 opacity 0，2s 后变为 1 */
.plus {
  display: inline-block;
  opacity: 0;
  transition: opacity 1.75s ease-in;
}
.plus.fade-in {
  opacity: 1;
}

/* label 淡入动画：采用 clip-path 实现从左向右逐步显示 */
.label-wrapper span {
  display: inline-block;
  clip-path: inset(0 100% 0 0);
  opacity: 0;
}
.label-wrapper span.label-fade {
  animation: revealText 1.75s forwards;
}
@keyframes revealText {
  from {
    clip-path: inset(0 100% 0 0);
    opacity: 0;
  }
  to {
    clip-path: inset(0 0 0 0);
    opacity: 1;
  }
}
/* 为避免 label 动画影响布局，外层容器保持固定宽度 */
.label-wrapper {
  overflow: hidden;
}
</style>
